import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

  const routes = [
    //默认
		{
			path: '/',
			redirect: '/index'
		},
    {
      path: '/main',
      name: 'main',
      component: () => import(/* webpackChunkName: "about" */ '../views/main.vue'),
      children: [
        {
          path: '/index',
          name: 'index',
          component: () => import(/* webpackChunkName: "about" */ '../views/index.vue')
        },
        {
          path: '/profile',
          name: 'profile',
          component: () => import(/* webpackChunkName: "about" */ '../views/profile.vue')
        },
        {
          path: '/news',
          name: 'news',
          component: () => import(/* webpackChunkName: "about" */ '../views/news.vue')
        },
        {
          path: '/achieve',
          name: 'achieve',
          component: () => import(/* webpackChunkName: "about" */ '../views/achieve.vue')
        },
        {
          path: '/publicity',
          name: 'publicity',
          component: () => import(/* webpackChunkName: "about" */ '../views/publicity.vue')
        },
        {
          path: '/contact',
          name: 'contact',
          component: () => import(/* webpackChunkName: "about" */ '../views/contact.vue')
        },
        {
          path: '/detail',
          name: 'detail',
          component: () => import(/* webpackChunkName: "about" */ '../components/detail.vue')
        }
      ]
    }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const VueRouterPush = VueRouter.prototype.push 
VueRouter.prototype.push = function push (to) {
    return VueRouterPush.call(this, to).catch(err => err)
}
export default router
